/* RESPONSIBLE TEAM: team-inbox-management */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class TicketsController extends Controller {
  queryParams = ['tab'];

  @tracked tab = 'ticket-types';

  get selectedTab() {
    return this.tab;
  }

  @action
  changeTab(tab: string) {
    this.set('tab', tab);
    this.tab = tab;
  }
}
